import { render, staticRenderFns } from "./ChoiceDetail.vue?vue&type=template&id=b8cbcd06&scoped=true"
import script from "./ChoiceDetail.vue?vue&type=script&lang=js"
export * from "./ChoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ChoiceDetail.vue?vue&type=style&index=0&id=b8cbcd06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cbcd06",
  null
  
)

export default component.exports